
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 127 127","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_558_1804)"}},[_c('path',{attrs:{"d":"M63.524 126.378c34.898 0 63.188-28.29 63.188-63.19C126.712 28.292 98.422 0 63.524 0 28.625 0 .334 28.29.334 63.189c0 34.898 28.291 63.189 63.19 63.189z","fill":"#6ECB63"}}),_c('path',{attrs:{"d":"M32.122 68.862a7.746 7.746 0 0111.769-10.07l7.673 8.994 32.654-25.99a7.752 7.752 0 019.646 12.133L55.357 84.58l-.003-.005a7.744 7.744 0 01-10.703-1.026L32.123 68.862h-.001z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_558_1804"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.335)","d":"M0 0h126.376v126.376H0z"}})])])])
          )
        }
      }
    